import { createEntityReducer } from "../../Redux/Entities";

export const commonEntitiesReducers = {
    tasks: createEntityReducer("tasks"),
    projects: createEntityReducer("projects"),
};
